import MainMenuItem, { MainMenuItemProps } from './MainMenuItem';

export type { MainMenuItemProps };
export default MainMenuItem;
